// This file was auto-generated using scripts/generate-icons.js
import type { JSX } from 'preact';

export type CheckAllIconProps = JSX.SVGAttributes<SVGSVGElement>;

/**
 * Icon generated from check-all.svg
 */
export default function CheckAllIcon(props: CheckAllIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      aria-hidden="true"
      viewBox="0 0 16 16"
      data-component="CheckAllIcon"
      {...props}
    >
      <g fill-rule="evenodd">
        <path fill="none" d="M0 0h16v16H0z" />
        <path
          fill="currentColor"
          d="M15.58 2.332a1 1 0 0 1 .235 1.394l-7 9.853a1 1 0 0 1-1.672-.065l-3-5a1 1 0 1 1 1.714-1.028l2.214 3.688 6.114-8.606a1 1 0 0 1 1.394-.236M.486 7.143a1 1 0 0 1 1.371.343l3 5a1 1 0 1 1-1.715 1.028l-3-5a1 1 0 0 1 .344-1.371"
        />
        <path
          fill="currentColor"
          d="M11.6 2.2a1 1 0 0 1 .2 1.4l-3 4a1 1 0 1 1-1.6-1.2l3-4a1 1 0 0 1 1.4-.2"
        />
      </g>
    </svg>
  );
}
